import React, {Component} from 'react';
import {connect} from 'react-redux';
import AiYearLogo from '../AiYearLogo';
import SocialLink from '../SocialLink';



class DefaultTemplateRTL extends Component {



	render() {

		return (
			<div dir={'rtl'} style={{textAlign:'right', minWidth:'600px', maxWidth:'600px', width: '600px'}} data-signature-root="true">
				<div style={{height: '10px', fontSize: '10px', lineHeight: '10px'}}>&nbsp;</div>
				<div style={{display: 'flex', width: '100%'}}>
					<div style={{borderLeft:  '1px solid #1da1f2', width:'150px', flex: '0 0 150px'}}>
						<img src={this.props.imageName} width="110px" style={{margin:  0, padding: '0px 10px 0px 10px'}} alt={this.props.name} />
					</div>
					<div style={{paddingRight:  '10px', flex: 1}}>
						<div style={{fontSize:  '20px', fontWeight: 'bold', color: '#32a1f2'}}>
							{!this.props.flag ? 'محمد عبدالله' : this.props.name}
						</div>
						<div style={{height: '8px', fontSize:  '8px', lineHeight: '8px'}}>&nbsp;</div>
						<div>
							{!this.props.flag ? 'الوظيفة  |  ' : this.props.jobTitle} {this.props.jobTitle === '' ? '' : '  |  '}
							{!this.props.flag ? 'القسم' : this.props.department}
						</div>
						<div>
							{!this.props.flag ?
								<>
									<img style={{width: '15px'}} src={`${process.env.PUBLIC_URL}/mobile.png`} alt={'mobile'} />
									&nbsp;
									 011/055
								</> :
								<>
									<img style={{width: '15px'}} src={`${process.env.PUBLIC_URL}/mobile.png`} alt={'mobile'} hidden={this.props.mobile === ''}/>
									&nbsp;
									{this.props.mobile}
								</>
							}
						</div>
						<div>
							{!this.props.flag ?
								<>
									<img style={{width:'15px'}} src={`${process.env.PUBLIC_URL}/email.png`} alt={'email'}/>
									&nbsp;
									m.abdullah@ksu.edu.sa
								</> :
								<>
									<img style={{width:'15px'}} src={`${process.env.PUBLIC_URL}/email.png`} alt={'email'} hidden={this.props.email === ''}/>
									&nbsp;
									{this.props.email}
								</>
							}
						</div>
						<div style={{height: '10px', fontSize:  '10px', lineHeight: '10px'}}>&nbsp;</div>
						<div style={{borderTop:  'solid 1px #1da1f2', paddingTop:  '5px', color:'#1da1f2'}}>
							{!this.props.flag ? 'https://ksu.edu.sa' : this.props.website}
						</div>
						<div style={{paddingTop:  '10px'}}>
							<div>
								<AiYearLogo style={{width: '95px', verticalAlign: 'middle'}}/>
							</div>
							<div className='d-flex flex-wrap align-items-center' style={{paddingTop: '5px'}}>
							{!this.props.flag ?
								<div className='d-inline mr-2'>
									<a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer " href='https://www.linkedin.com'>
										<img className='mr-1' style={{width:'20px'}} src={`${process.env.PUBLIC_URL}/linkedin.png`} alt={'linkedin'}/>
									</a>
								</div>
								: (this.props.linkedin !== '' && <SocialLink href={this.props.linkedin} icon={`${process.env.PUBLIC_URL}/linkedin.png`} alt={'linkedin'} width={'20px'}/>)}
							{!this.props.flag ?
								<div className='d-inline mr-2'>
									<a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.x.com'>
										<img className='mr-1' style={{width:'20px'}}  src={`${process.env.PUBLIC_URL}/x.svg`} alt={'X'}/>
										
									</a>
								</div>
								: (this.props.twitter !== '' && <SocialLink href={this.props.twitter} icon={`${process.env.PUBLIC_URL}/x.svg`} alt={'X'} width={'20px'}/>)}

							{!this.props.flag ?
								<div className='d-inline'>
									<a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.facebook.com/'>
										<img className='mr-1' style={{width:'20px'}}  src={`${process.env.PUBLIC_URL}/facebook.png`} alt={'facebook'}/>
										
									</a>
								</div>
								: ( this.props.facebook !== '' && <SocialLink href={this.props.facebook} icon={`${process.env.PUBLIC_URL}/facebook.png`} alt={'facebook'} width={'20px'}/>)}

							{/* {!this.props.flag ?
								(<a target="_blank" rel="noopener noreferrer" href='https://www.github.com/'><img style={{width: '20px'}} src={`${process.env.PUBLIC_URL}/github.png`} alt={'github'}/></a>
								): (this.props.github !== '' && <a target="_blank" rel="noopener noreferrer" href={this.props.github}><img style={{width:'20px'}}  src={`${process.env.PUBLIC_URL}/github.png`} alt={'github'}/></a>)}&nbsp;&nbsp; */}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		flag: state.ArabicReducer.flag,
		name: state.ArabicReducer.ar_name,
		email: state.ArabicReducer.ar_email,
		jobTitle: state.ArabicReducer.ar_jobTitle,
		department: state.ArabicReducer.ar_department,
		mobile: state.ArabicReducer.ar_mobile,
		website: state.ArabicReducer.ar_website,
		imageName: state.imageReducer.image,
		linkedin: state.socialReducer.linkedin,
		twitter: state.socialReducer.twitter,
		facebook: state.socialReducer.facebook,
		github: state.socialReducer.github,
	};
}

export const defaultTemplateRTL =  connect(mapStateToProps)(DefaultTemplateRTL);
